import React from 'react';
import Translate from '../../../components/shared/localization/localize';
import { Activity } from '../../../modules/dialogs/transfer/model';
import * as m from '../../../modules/dialogs/transfer/messages';
import {
  TransferStatus,
  TransferType,
} from '../../../modules/dialogs/transfer/consts';
import { KFLButton } from '@kamstrup/kamstrup-frontend-library';
import { MessageType } from '../../../core/localization';
import EksKFLWrapper from '../../shared/eks-lib/eksKFLwrapper';

interface Props {
  a: Activity;
  isSender: boolean;
  onDetails: () => void;
}

const LogTitle: React.FC<Props> = ({ a, isSender, onDetails }) => {
  let msg: MessageType = '';
  if (a.status === TransferStatus.COMPLETED)
    msg = isSender ? m.msgSent : m.msgReceived;
  else if (a.type === TransferType.REQUEST)
    msg = isSender ? m.msgRequest : m.msgRequested;

  return (
    <span data-id={a.id}>
      <EksKFLWrapper>
        <Translate message={msg}></Translate>
        {' - '}
        <KFLButton variant="borderless" onClick={onDetails}>
          <Translate message={m.msgDevice(a.numDevices)}></Translate>
        </KFLButton>
      </EksKFLWrapper>
    </span>
  );
};

export default LogTitle;
